// extracted by mini-css-extract-plugin
module.exports = {"background":"Z_dS","shopping__wrapper__examples":"Z_fd","active":"Z_ff","shopping__wrapper__project":"Z_fg"};